/** Subscribe to a MediaQueryList, falling back to the legacy addListener API (Safari ≤ 13). */
export function watchMediaQuery(list: MediaQueryList, onChange: () => void): () => void {
  if (typeof list.addEventListener === 'function') {
    list.addEventListener('change', onChange);
    return () => list.removeEventListener('change', onChange);
  }
  const legacy = list as MediaQueryList & {
    addListener?: (cb: () => void) => void;
    removeListener?: (cb: () => void) => void;
  };
  legacy.addListener?.(onChange);
  return () => legacy.removeListener?.(onChange);
}
